<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nuevo' }} modelo</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="onSubmit">
          <validation-provider #default="{ errors }" name="name" rules="requeridoE">
            <b-form-group label="Nombre" label-for="nombre">
              <b-form-input
                id="nombre"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Nombre"
                v-model="items.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VehicleService from '@/services/VehicleService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        id: null,
        name: '',
      },
      data: {
        id: null,
        name: '',
      },
      temp: {}
    }
  },
  mounted(){
    this.getMake()
  },
  methods: {
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items
        this.items = items
        this.isEdit = true
      } else {
        this.temp = {}
        this.items = {
          name: '',
        }        
        this.isEdit = false
      }
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.temp = {
        name: '',
      }
      this.isEdit = false
      this.items = this.temp
    },
    async getMake(){
      const resp = await VehicleService.getVehicleById(this.$route.params.id, this.$store)
      if(resp){
        this.data.id = resp.id
        this.data.name = resp.name
      }
    },
    async onSubmit() {
      let datos = {}
      datos.brandId = parseInt(this.$route.params.id)
      datos.name = this.items.name
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          if (this.isEdit == false) {
            resp = await VehicleService.saveModel(datos, this.$store)
          } else {
            resp = await VehicleService.updateModel(this.items.id, datos, this.$store)
          }
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'El modelo ha sido ' + (this.isEdit == true ? 'actualizado.' : 'registrado.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' el modelo',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } 
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
